import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as globalActions from '../core/global/globalActions';
import { getPageByName } from '../core/global/globalSelectors';

import BookSessionPage from '../pages/BookSessionPage';

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        profile: state.profile,
        pageContent: getPageByName(state, 'book-session')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...globalActions
        }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookSessionPage);



/** WEBPACK FOOTER **
 ** ./src/containers/BookSession.js
 **/